class StickyForm extends HTMLElement {
  connectedCallback() {
    this.mainProduct = document.querySelector('main-product');
    if (!this.mainProduct) return;

    this.mainForm = this.mainProduct.querySelector('form');
    this.mainButton = this.mainProduct.querySelector('button.buy-now');
    this.form = this.querySelector('form');
    this.toggle = this.querySelector('.sticky-form__toggle');
    this.buyButton = this.querySelector('.sticky-form__buy');

    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.form.addEventListener('change', event => this.onChange(event), { signal });
    this.mainForm.addEventListener('change', () => this.sync(), { signal });
    this.buyButton.addEventListener('click', () => this.mainButton.click(), { signal });
    this.toggle.addEventListener('click', () => this.setOpen(!this.classList.contains('open')), { signal });
    window.addEventListener('scroll', () => this.updateVisibility(), { signal, passive: true });

    this.observer = new IntersectionObserver(([entry]) => {
      this.mainVisible = entry.isIntersecting;
      this.updateVisibility();
    });
    this.observer.observe(this.mainProduct);
    this.sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  onChange(event) {
    const { name, value } = event.target;
    this.mainForm.querySelector(`input[name="${name}"][value="${value}"]`).click();
  }

  sync() {
    const fields = this.mainForm.elements;
    ['mode', 'size', 'flavour', 'purchase'].forEach(name => {
      if (this.form.elements[name] && fields[name]) this.form.elements[name].value = fields[name].value;
    });
    this.form.querySelectorAll('input[name="size"]').forEach(input => {
      input.disabled = this.mainForm.querySelector(`input[name="size"][value="${input.value}"]`).disabled;
    });
    this.classList.toggle('is-variety', fields.mode?.value === 'variety');

    this.buyButton.disabled = this.mainButton.disabled;
    this.querySelector('[data-buy-label]').textContent = this.mainButton.querySelector('[data-buy-label]').textContent;
    this.querySelector('[data-buy-price]').textContent = this.mainButton.querySelector('.sticky-price').textContent;

    const saving = this.querySelector('[data-saving]');
    if (saving) saving.textContent = this.mainProduct.querySelector('[data-saving]').textContent;
  }

  setOpen(open) {
    this.classList.toggle('open', open);
    this.toggle.setAttribute('aria-expanded', open);
  }

  updateVisibility() {
    const visible = window.scrollY > 500 && !this.mainVisible;
    this.classList.toggle('visible', visible);
    if (!visible) this.setOpen(false);
  }
}

customElements.define('sticky-form', StickyForm);
